<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>

<template>
  <div :class="cn('flex flex-col gap-y-2 p-3 pt-2 pb-2 border-b border-border bg-muted/60 dark:bg-[hsl(var(--border))]', props.class)">
    <slot />
  </div>
</template>
